module.exports = __webpack_public_path__ + "img/sign-81.7fd54402.jpg";